<template>
  <div>
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        class="border-table-business text-no-wrap table-approve"
        item-key="_id"
        v-model="selected"
        :headers="headers"
        :items="dataSource"
        :loading="loading"
        :expanded.sync="expanded"
        loader-height=0
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="total || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        disable-sort
        :page.sync="page"
        :items-per-page="perPage"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <!-- <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
          <v-checkbox
            v-if="item.requestStatus==='pending' && isAdmin"
            v-show="true"
            v-model="item.selected"
            :value="isSelected"
            hide-details
            class="ma-0"
            style="width: 0px;"
            @change="select($event)"
          />
        </template> -->
        <template v-slot:[`item.no`]="{ item }">
          {{ (perPage*(page-1)) + dataSource.indexOf(item)+1 }}
        </template>
        <!-- <template v-slot:[`item.companyImage`]="{ item }">
          <td style="width: fit-content !important;" class="py-2">
            <v-avatar
              size="50"
              rounded
            >
              <v-img
                contain
                :lazy-src="require('@/assets/icons/company-logo3.png')"
                :src="item.failed_image ? require('@/assets/icons/company-logo3.png') : item.companyImage"
                :alt="item.employeeId"
                v-on:error="onImgError(item.no-1)"
                aspect-ratio="2.7"
              />
            </v-avatar>
          </td>
        </template> -->
        <template v-slot:[`item.updateAt`]="{ item }">
          {{ item.updateAt }}
        </template>
        <template v-slot:[`item.statusActive`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on">
                <v-switch
                  v-model="item.statusActive"
                  style="transform: scale(0.8); margin-left: -15px;"
                  color="#2BA197"
                  flat
                  inset
                  dense
                  :disabled="item.adminLock===true && approveRole === 'User'"
                  @change="toggleStatus(item)"
                ></v-switch>
              </div>
            </template>
            <!-- <span class="label-table-action">เปิด/ปิด การใช้งาน Service <br>เมื่อปิดใช้งานจะไม่สามารถ <br>login เข้า Service นี้ได้</span> -->
            <span class="label-table-action">เปิด/ปิด การใช้งานของ Token</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                color="#2BA197"
                dark
                icon
                class="ra-border-button mt-3 mb-3"
                @click="view(item)"
              >
              <v-icon class="icon-eye-color" small>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">ดูรายละเอียด</span>
          </v-tooltip>
          <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  color="#FFB300"
                  dark
                  icon
                  class="ra-border-button mt-3 mb-3 ml-2"
                  @click="checkActionType(item)"
                >
                <v-icon color="error" small>mdi-close</v-icon>
                </v-btn>
              </template>
              <span class="label-table-action">ลบข้อมูล</span>
            </v-tooltip>
        </template>
        <template v-slot:item.data-table-expand="{ expand, isExpanded, item }">
          <v-row class="d-flex px-4">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  color="#2BA197"
                  dark
                  icon
                  class="ra-border-button mt-3 mb-3"
                  @click="view(item)"
                >
                <v-icon class="icon-eye-color" small>mdi-eye</v-icon>
                <!-- <img width="20" height="10" src="@/assets/icons/eye-view.png" > -->
                </v-btn>
              </template>
              <span class="label-table-action">ดูรายละเอียด</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn
                  v-if="item.statusDelete === true"
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  color="#F5F5F5"
                  dark
                  icon
                  class="ra-border-button mt-3 mb-3 ml-2"
                >
                <v-icon color="error" small>mdi-close</v-icon>
                </v-btn> -->
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  color="#FFB300"
                  dark
                  icon
                  class="ra-border-button mt-3 mb-3 ml-2"
                  @click="checkActionType(item)"
                >
                <v-icon color="error" small>mdi-close</v-icon>
                </v-btn>
              </template>
              <span class="label-table-action">ลบข้อมูล</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
      <v-row>
      <v-col cols="12" class="pa-0">
      <div class="justify-end d-flex align-end pt-4">
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination>
      </div>
      </v-col>
    </v-row>
    </div>
    <!-- <DialogShowDetail/> -->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="344"
      max-height="232"
    >
      <v-card tile class="justify-center">
        <v-card-title class="justify-center">
          {{modeUpdate}}
          <span style="font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 16px; line-height: 22px; text-align: center; color: #3776E9;">
            {{ modeUpdate=='approve'? workfor=='approve'? 'ต้องการอนุมัติคำร้องใช่ไหม':'ต้องการไม่อนุมัติคำร้องใช่ไหม':'ต้องการรับทราบคำร้องใช่ไหม' }}
          </span>
        </v-card-title>
        <v-card-subtitle class="layout justify-center pt-1">
          <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
            {{ modeUpdate=='approve'? workfor=='approve'? 'คุณแน่ใจหรือไม่ว่าต้องการอนุมัติคำร้อง':'คุณแน่ใจหรือไม่ว่าไม่ต้องการอนุมัติคำร้อง':'คุญแน่ใจหรือไม่ว่าต้องการรับทราบคำร้อง' }}
          </span>
        </v-card-subtitle>
        <v-textarea v-model="comment" class="ml-8 mr-8" outlined rows="2" placeholder="ระบุความเห็น" v-if="modeUpdate=='approve'"></v-textarea>
        <v-card-actions class="justify-center pb-4">
           <v-btn
              color="primary"
              outlined
              class="head-search-button mr-4"
              width="83"
              @click="dialog = false"
            >
            ยกเลิก
            </v-btn>
            <v-btn
              color="primary"
              class="head-search-button ml-4 white--text text--lighten-4"
              elevation="0"
              width="83"
              @click="updateStatusApprove(modeUpdate, comment)"
            >
            ยืนยัน
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmDel" max-width="500px">
      <v-card height="180px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูล</span>
        <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirmDel = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="deleteExternalToken()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          text
          top
          app
          class="content-alert"
        >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </v-row>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import OverlayLoading from '../../_template/OverlayLoading.vue'
import { fetchAllRequesManageExternalToken, deleteExternalTokenById } from '@/API/API'
const swal = require('sweetalert')
const axios = require('axios')
const moment = require('moment')
export default {
  name: 'tree',
  components: {
    OverlayLoading
  },
  props: {
    mode: String
  },
  data () {
    return {
      expanded: [],
      dialog: false,
      dialogConfirmDel: false,
      workfor: 'approve',
      comment: '',
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      // isAdmin: localStorage.approveRole === 'Super Admin' ? localStorage.approveRole === 'Super Admin' : false,
      isAdmin: this.$store.state.user.role[1].permission === 'Super Admin' ? this.$store.state.user.role[1].permission === 'Super Admin' : false,
      singleSelect: false,
      allowBtnApprove: false,
      allowBtnReject: false,
      loading: false,
      modeUpdate: 'approve',
      filterData: {
        businessType: '',
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.modeUpdate,
        createAt: '',
        updateAt: '',
        limit: 15,
        page: 1
      },
      textBtnOk: this.modeUpdate === 'approve' ? 'อนุมัติ' : 'รับทราบ',
      textBtnNO: this.modeUpdate === 'approve' ? 'ไม่อนุมัติ' : 'ไม่รับทราบ',
      statusList: [
        // { status: 'pending', statusTH: 'กำลังดำเนินการ', color: '#00B0FF' },
        { status: 'pending', statusTH: 'รออนุมัติ', color: '#E9A016' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' }
      ],
      headers: [
        {
          text: 'ลำดับ',
          value: 'no',
          width: '70px'
        },
        { text: 'ชื่อโปรเจค', value: 'projectName' },
        { text: 'ชื่อผู้ร้องขอ', value: 'userName' },
        // { text: 'บริษัท', value: 'createAt' },
        { text: 'สถานะ', value: 'statusActive' },
        { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '130px', align: 'center fixed', class: 'column-fix' }

      ],
      checkBtnRehister: false,
      selected: [],
      dataSource: [],
      serviceTypeList: [],
      requestStatusList: [],
      total: -1,
      perPage: 15,
      pageCount: 0,
      page: 1,
      textCondition: {
        new: 'เพิ่มบุคคล',
        transfer: 'ขอย้ายฝ่าย',
        resign: 'ขอลาออก',
        transferPosition: 'ย้ายตำแหน่ง',
        resignPosition: 'ลาออกจากตำแหน่ง',
        resignEmployee: 'ลาออกจากบริษัท'
      },
      approveRole: localStorage.approveRole

    }
  },
  async created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    // await this.searchFilterData(this.filterData)
    // this.isAdmin = this.$store.state.user.role[1].permission === 'Super Admin'
    // this.loading = true
  },
  beforeDestroy () {
    EventBus.$off('openDialogManageApprove')
    EventBus.$off('manageExternalToken')
    EventBus.$off('updateStatusToken')
    EventBus.$off('setApproveRole')
    this.loading = false
  },
  mounted () {
    EventBus.$on('manageExternalToken', this.setFilter)
    EventBus.$on('updateStatusToken', this.setFilter)
    EventBus.$on('setApproveRole', this.setApproveRole)
  },
  methods: {
    onImgError (i) {
      this.dataSource[i].failed_image = true
    },
    changePerPage (value) {
      this.perPage = value
      this.setFilter(this.filterData)
    },
    changePage (value) {
      this.page = value
      this.setFilter(this.filterData)
    },
    setApproveRole () {
      this.approveRole = localStorage.approveRole
    },
    async setFilter (value) {
      this.filterData = value
      var searchPayload = {
        tap: 'tokenTap',
        projectName: this.filterData.projectName,
        userName: this.filterData.userName,
        role: this.filterData.role || this.approveRole,
        limit: this.perPage,
        page: this.page
      }
      this.searchFilterData(searchPayload)
    },
    async searchFilterData (value) {
      const self = this
      const temp = []
      self.loading = true
      self.selected = []
      self.filterData = value
      self.isAdmin = localStorage.approveRole === 'Super Admin'
      try {
        const res = await fetchAllRequesManageExternalToken(value, this.$store.state.token)
        if (res.success) {
          res.result.map((el, index) => {
            el.companyImage = `${this.api}/api/vMonk/companys/getcompanyFileById/` + el.companyImage
            temp.push({
              no: index + 1,
              failed_image: false,
              ...el
            })
          })
          self.total = res.count || -1
          EventBus.$emit('updateTotalMarket', {
            totalAll: res.totalAll,
            totalApproved: res.totalApproved,
            totalPending: res.totalPending,
            totalRejected: res.totalRejected,
            totalWaiting: res.totalWaiting,
            totalCancle: res.totalCancel
          })
          self.total = res.total || -1
          // if (self.total + 1 === 0 && !self.isAdmin) {
          //   this.dialogRegisterCompany = true
          // }
          self.dataSource = temp || []
          self.computeData(self.dataSource)
          // EventBus.$emit('checkBtnRegister', res.checkReq)
        } else {
          self.dataSource = []
        }
      } catch (error) {
        console.log(error)
        self.dataSource = []
      } finally {
        self.loading = false
      }
    },
    async computeData (item) {
      await item.map(e => {
        e.createAt = moment(e.createAt).format('DD/MM/YYYY HH:mm น.')
        e.updateAt = moment(e.updateAt).format('DD/MM/YYYY HH:mm น.')
      })
    },
    // async updateAcknowledge (listId) {
    //   var obj = {
    //     acknowledgeList: listId
    //   }
    //   // console.log(obj)
    // },
    view (item) {
      this.$router.push('manageapprovetoken/update/' + item._id)
      // this.$router.push('manageapprovetoken/update/' + '60f912a3481b223ec86943ec')
    },
    checkActionType (item) {
      this.reqTokenId = item._id
      if (this.approveRole === 'Super Admin') {
        this.approveType = 'ยกเลิก'
        this.dialogConfirmDel = true
      } else {
        this.dialogApproverCompany = true
      }
    },
    checkAllowBtn () {
      if (this.selected.length > 0) {
        this.allowBtnApprove = true
        this.allowBtnReject = true
      } else {
        this.allowBtnApprove = false
        this.allowBtnReject = false
      }
    },
    clickApprove () {
      this.comment = ''
      this.dialog = true
      this.workfor = this.modeUpdate === 'approve' ? 'approve' : 'acknowledge'
    },
    clickReject () {
      this.comment = ''
      this.dialog = true
      this.workfor = 'reject'
    },
    async deleteExternalToken () {
      const obj = {
        tokenId: this.reqTokenId
      }
      try {
        const res = await deleteExternalTokenById(obj, this.$store.state.token)
        if (res.success) {
          // swal('สำเร็จ', 'คุณได้ทำการลบข้อมูล เรียบร้อยแล้ว', 'success', {
          //   button: false,
          //   timer: 2000
          // })
          this.dialogConfirmDel = false
          this.text = 'คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว'
          this.snackbarColor = 'success'
          this.snackbar = true
          this.dialogConfirmDel = false
          // this.initData()
          EventBus.$emit('updateDataDelete')
          this.setFilter(this.filterData)
        } else {
          this.dialogConfirmDel = false
          swal('ผิดพลาด', 'ไม่สาารถลบข้อมูลได้ กรุณาลองใหม่', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
      }
      // this.text = 'คุณได้ทำการลบข้อมูลผู้อนุมัติเรียบร้อยแล้ว'
      // this.snackbar = true
    },
    async toggleStatus (item) {
      this.loading = true
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/externalApi/changStatusActiveTokenByRole`,
          method: 'POST',
          data: {
            // serviceStatus: item.serviceStatus === 'on' ? 'off' : 'on',
            statusActive: item.statusActive,
            tokenId: item._id,
            role: this.approveRole
          },
          headers: {
            authorization: this.$store.state.token
          }
        })
          .then((response) => {
            if (response.data.success) {
              swal('สำเร็จ', 'เปลี่ยนสถานะสำเร็จ', 'success', {
                button: false,
                timer: 1000
              })
              this.searchFilterData(this.filterData)
            }
          })
      } catch (error) {
        swal('ผิดพลาด', 'เปลี่ยนสถานะไม่สำเร็จ กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
        this.searchFilterData(this.filterData)
      } finally {
        // await this.searchFilterData()
        this.loading = false
      }
    },
    async updateStatusApprove (task, modeUpdate, comment) {
      const self = this
      var confirmList = []
      self.selected.forEach(e => {
        confirmList.push(
          {
            requestStatus: task,
            _id: e._id
          }
        )
      })
      // await axios({
      //   url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/companys/updateStatusReqCompanyByToken`,
      //   method: 'POST',
      //   headers: {
      //     authorization: this.$store.state.token
      //   },
      //   data: {
      //     approveList: confirmList
      //   }
      // })
      //   .then((response) => {
      //     if (response.data.success === true) {
      //       // swal('สำเร็จ', 'ทำรายการเรียบร้อย', 'success', {
      //       //   button: false,
      //       //   timer: 2000
      //       // })
      //       this.dialog = false
      //       this.snackbar = true
      //       this.page = 1
      //       self.searchFilterData(self.filterData)
      //     } else {
      //       swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
      //         button: false,
      //         timer: 2000
      //       })
      //     }
      //   })
      //   .catch(function (thrown) {
      //     swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
      //       button: false,
      //       timer: 2000
      //     })
      //   })
    },
    select (event) {
      this.checkAllowBtn()
    },
    selectAllToggle (props) {
      if (this.selected.length === 0) {
        this.selected = []
        const self = this
        props.items.forEach(item => {
          if (item.status === 'pending') {
            self.selected.push(item)
          }
        })
      } else this.selected = []
    }
  }
}
</script>

<style>
/* table */
.theme--light.v-pagination .v-pagination__item--active {
    background: #2BA197 !important;
    color: #FFFFFF;
}
.v-pagination__item {
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    height: 30px;
    margin: 0.3rem;
    min-width: 30px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.v-pagination__navigation {
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 30px;
    width: 30px;
    margin: 0.3rem 10px;
}
/* end */
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}
</style>

<style scoped>

/* .table-approve >>> table > tbody > tr > td:nth-child(1),
.table-approve >>> table > thead > tr > th:nth-child(1) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 0;
} */

/* .table-approve >>> table > tbody > tr > td:nth-child(2),
.table-approve >>> table > thead > tr > th:nth-child(2) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 56px;
}

.table-approve >>> table > tbody > tr > td:nth-child(3),
.table-approve >>> table > thead > tr > th:nth-child(3) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 126px;
} */

/* .table-approve >>> table > tbody > tr:hover > td:nth-child(1),
.table-approve >>> table > tbody > tr:hover > td:nth-child(2),
.table-approve >>> table > tbody > tr:hover > td:nth-child(3) {
  background: #eeeeee;
}

.table-approve >>> table > thead > tr > th:nth-child(1),
.table-approve >>> table > thead > tr > th:nth-child(2),
.table-approve >>> table > thead > tr > th:nth-child(3) {
  background-color: #F8F9FB;
}

.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(1),
.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(2),
.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(3) {
  background: #f7f7f7;
}

.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(1),
.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(2),
.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(3) {
  background: #eeeeee;
} */
.border-table-business {
  border-radius: 10px;
  border: 1px solid rgb(229, 236, 238);
}

table > tbody > tr > td.fixed:nth-last-child(1),
table > thead > tr > th.fixed:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  /* z-index: 9997; */
  background: white;
  /* background: transparent; */
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}

table > tbody > tr:hover > td.fixed:nth-last-child(1), table > thead > tr:hover > th.fixed:nth-last-child(1) {
  background: #eeeeee;
}

table > thead > tr > th.fixed:nth-last-child(1) {
  /* z-index: 9998; */
  background-color: #F8F9FB;
}
.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
.content-alert >>> .v-snack__wrapper {
  min-width: 15px !important;
}
</style>
